import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mobileMask',
  standalone: false
})
export class MobileMaskPipe implements PipeTransform {

  transform(value: string | number): string {
    const mobile = value?.toString();
    if (!mobile || mobile.length < 6) return mobile;

    return `${mobile.slice(0, 2)}*****${mobile.slice(-3)}`;
  }

}
